import { useEffect } from 'react'
import { PeerEvents } from '@gameglass/webrtc'
import { webrtc } from '~/providers/MfdProvider'

export const useEDDataBridge = (connection, token) => {
  useEffect(() => {
    const sendEDData = async ({ data }) => {
      if (data?.type === 'edState' && data?.payload) {
        try {
          const child = await connection.current.promise

          await child.edState(data?.payload)
        } catch (error) {
          console.warn(error)
        }
      }
    }

    webrtc.on(PeerEvents.data, sendEDData)

    return () => {
      webrtc.off(PeerEvents.data, sendEDData)
    }
  }, [token])
}